module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-oem.60668475.png";